// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606190501/js/" + chunkId + "." + {"44":"0b7c943d","225":"a7bf7b34","481":"d2a7ee3e","486":"0c468fd7","770":"1307975e"}[chunkId] + ".0.40355311887930634.chunk.js";
};